export default "__VITE_ASSET__19a0418c__"